import React from "react";
import { Col, Row, Typography } from "antd";
import Cards, { Focused } from "react-credit-cards";
import { formatCurrency, isMobile } from "../../../../../utils";
import { Plan as IPlan, UserPlan } from "../../../../../constants/plans";

interface IInfoCardProps {
  cvc: string;
  name: string;
  expiry: string;
  number: string;
  focused?: Focused;
  plan?: IPlan | UserPlan;
  uniqueValue?: number;
  value: number;
}

const InfoCard: React.FC<IInfoCardProps> = ({
  cvc,
  name,
  plan,
  number,
  expiry,
  focused,
  value,
  uniqueValue,
}) => {
  const getMessage = () => {
    if (plan) {
      return `Realize o pagamento com cartão de crédito para ter acesso ao Plano ${plan?.title.toUpperCase()}.`;
    }

    if (uniqueValue) {
      return `Realize o pagamento do seu DARF com o cartão de crédito`;
    }
  };

  return (
    <Row style={{ marginBottom: "32px" }}>
      {!isMobile() && (
        <>
          <Col span={24} style={{ textAlign: "center" }}>
            <Typography.Paragraph
              style={{
                marginBottom: "0px",
                color: "var(--velotax-font-color-dark)",
              }}
            >
              {getMessage()}
            </Typography.Paragraph>
          </Col>
          <Col span={24}>
            <Typography.Paragraph
              style={{
                fontSize: 18,
                fontWeight: "500",
                textAlign: "center",
                textTransform: "uppercase",
                color: "var(--ant-primary-color)",
              }}
            >
              {(plan as UserPlan)?.maskValue ? undefined : plan?.title}
              {(plan as UserPlan)?.maskValue ? (
                <></>
              ) : value ? (
                <strong> {formatCurrency(value ?? 0)}</strong>
              ) : undefined}
            </Typography.Paragraph>
          </Col>
        </>
      )}

      <Col span={24} className="form-card-container">
        <Cards
          preview
          cvc={cvc}
          name={name}
          expiry={expiry}
          number={number}
          focused={focused}
          locale={{ valid: "Validade" }}
          placeholders={{ name: "Nome completo" }}
        />
      </Col>
    </Row>
  );
};

export default InfoCard;
